<script>

    import { toast } from 'bulma-toast'

    import CatalogsService from '../$services/catalogs.service'

    import InputText from '../$components/input.text.svelte'

    $: unitName && (query.find = unitName)

    export let unitName = null
    export let unitCode = null

    let loading = false
    let showList = false
    let query = {}
    let units = []
    
    async function getSatUnits() {

        showList = false
        unitName = null
        unitCode = null
    
        loading = true
        const resp = await CatalogsService.getSatUnits(query)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        units = resp.data
        showList = !!units.length
    }

    function onSelected(item) {
        query.find = item.unitName
        unitCode = item.unitCode
        unitName = item.unitName
        units = []
        showList = false
    }

</script>

<style>
    .relative{
        position: relative;
        top: -14px;
    }
    .boxed {
        width: 100%;
        max-height: 200px;
        overflow-y: auto;
        background: whitesmoke;
        border-radius: 0 0 8px 8px;
        position: absolute;
        z-index: 5;
    }
    .item {
        padding: 8px;
        cursor: pointer;
    }
    .item:hover {
        background: #F2E612;
        font-weight: bold;
        color: white;
    }
</style>

<InputText bind:value={query.find} icon="tag" iconRight={ unitCode? 'check' : null } label="Unidad de medida" placeholder="Buscar unidad de medida"
    on:keyup={getSatUnits} 
    on:blur={() => showList = false} 
    on:focus={() => showList = true} 
    {loading}
/>
<small>Presentación del producto, por ejemplo: pieza, par, docena, bolsa, caja.</small>
{#if showList || !unitCode}
    <div class="relative">
        <div class="boxed">
            {#each units as unit}
                <div on:click={() => onSelected(unit)} class="item">{ unit.unitName }</div>
            {/each}
        </div>
    </div>
{/if}
{#if unitCode}
    <div class="items end">
        <small>Código { unitCode }</small>
    </div>
{/if}